/**
 * 这里是以绿色主题做注释的，他们的转换公式都是相同的
 * 建议多处使用到的颜色才放进公式中， 否则使用light-1 -> 9逐渐变浅， shade-1 -> 2逐渐变深，来使用相近颜色即可，否则公式会变的臃肿难以维护
 * shade(加深本色) rgb(255, 0, 0) shade(50%) -> rgb(128, 0, 0)往黑色靠近
 * tint减淡本色(实际是加深他的混入色)  rgb(255, 0, 0) tint(50%) -> rgb(255, 128, 128)
 * blend混入 rgb(255, 0, 0) blend(black 50%) -> rgb((255 + 0) * 50%, (0 + 0) * 50%, (0 + 0) * 50%)
 * */
const formulaColor = {
  'shade-1': 'color(primary shade(10%))',
  'shade-2': 'color(primary shade(20%))',
  'light-1': 'color(primary tint(10%))',
  'light-2': 'color(primary tint(20%))',
  'light-3': 'color(primary tint(30%))',
  'light-4': 'color(primary tint(40%))', // 一些小按钮的掠过颜色，掠过加深一点
  'light-5': 'color(primary tint(50%))', // 普通button按钮hover时的背景色或一些小按钮，比如el-dropdown的按钮的颜色
  'light-6': 'color(primary tint(60%))',
  'light-7': 'color(primary tint(70%))', // 分页栏的背景色
  'light-8': 'color(primary tint(80%))', // 报表选中行的背景色
  'light-9': 'color(primary tint(90%))', // 报表行hover时的背景色
  'light-bg-1': 'color(primary tint(95%))', // 最淡的背景色, 一般是hover的时候使用
  'font-1': 'color(primary red(+ 25) green(- 29) blue(+ 8))' // 登录界面的深字体颜色，深色字体统一用该配色
}

export default formulaColor



// WEBPACK FOOTER //
// ./src/plugins/theme/formulaColor.js